export const SistemaDisponibleFields = {
    CodSistema: 'id',
    NombreSistema: 'vchNombreSistema',
    Activo: 'bitActivo'
} as const

export type SistemaDisponibleDTO = {
    [SistemaDisponibleFields.CodSistema]: number
    [SistemaDisponibleFields.NombreSistema]: string
    [SistemaDisponibleFields.Activo]: boolean
}

export const GrupoDisponibleFields = {
    IdGrupo: 'intIdGrupo',
    NombreGrupo: 'vchDescSegGrupo',
    PerteneceASector: 'bitPerteneceASector'
} as const

export type GrupoDisponibleDTO = {
    [GrupoDisponibleFields.IdGrupo]: number
    [GrupoDisponibleFields.NombreGrupo]: string
    [GrupoDisponibleFields.PerteneceASector]: number
}

export const SectorDisponibleFields = {
    CodSector: 'sinCodSectorComercial',
    NombreSector: 'vchNombreSectorComercial',
    Activo: 'bitActivo'
} as const

export type SectorDisponibleDTO = {
    [SectorDisponibleFields.CodSector]: number
    [SectorDisponibleFields.NombreSector]: string
    [SectorDisponibleFields.Activo]: number
}
